import pick from 'lodash/pick';
import 'whatwg-fetch';
import api from '../common/utils/api';
import { mutateAdmin, queryAdmin } from '../graphql-client';

export const CREATE_PROJECT_MUTATION = /* GraphQL */ `
  mutation ($name: String!, $defaultTimezone: String!) {
    project: createProject(name: $name, defaultTimezone: $defaultTimezone) {
      id
      name
      defaultTimezone
    }
  }
`;

export const IMPORT_PROJECT_URI_MUTATION = /* GraphQL */ `
  mutation ($name: String!, $uri: String!) {
    importId: importProject(name: $name, uri: $uri, origin: "@takeshape/client")
  }
`;

export const UPLOAD_PROJECT_MUTATION = /* GraphQL */ `
  mutation ($name: String, $type: String) {
    upload: uploadProject(name: $name, type: $type, origin: "@takeshape/client") {
      uri,
      importId
    }
  }
`;

export const UPDATE_PROJECT_SETTINGS_MUTATION = /* GraphQL */ `
  mutation ($id: String!, $name: String, $avatarId: ID, $defaultTimezone: String) {
    updateProject(projectId: $id, name: $name, avatarId: $avatarId, defaultTimezone: $defaultTimezone) {
      id
      name
      avatar {
        _id
        path
      }
      defaultTimezone
    }
  }
`;

export const GET_PROJECT = /* GraphQL */ `
  query getProject($projectId: String!) {
    project: getProject(projectId: $projectId) {
      id
      name
      status
      avatar {
        _id
        path
      }
      defaultTimezone
    }
  }
`;

export const GET_PROJECT_LIST = /* GraphQL */ `
  query getProjectList {
    projects: getProjectList {
      id
      name
      invite
      status
      type
      avatar {
        _id
        path
      }
    }
  }
`;

export const GET_PROJECT_MEMBERS = /* GraphQL */ `
  query getProjectMembers {
    members: getProjectMembers {
      fullName
      email
      id
      role
    }
  }
`;

export const GET_PROJECT_ADMINS = /* GraphQL */ `
  query getProjectAdmins {
    admins: getProjectAdmins {
      fullName
      email
    }
  }
`;

export const UPDATE_PROJECT_PERMISSIONS = /* GraphQL */ `
mutation ($userId: ID!, $role: String!) {
  updateProjectPermissions(userId: $userId, role: $role) {
    userId
    role
  }
}
`;

export const UPDATE_INVITATION_ROLE = /* GraphQL */ `
mutation ($email: String!, $role: String!) {
  updateInviteRole(email: $email, role: $role) {
    email
    role
  }
}
`;

export const CANCEL_PROJECT_INVITE = /* GraphQL */ `
mutation ($email: String!) {
  cancelProjectInvite(email: $email) {
    email
  }
}
`;

export const REMOVE_PROJECT_MEMBER = /* GraphQL */ `
mutation ($userId: ID!) {
  removeProjectMember(userId: $userId) {
    userId
  }
}
`;

export const DELETE_PROJECT = /* GraphQL */ `
mutation ($projectId: ID!) {
  deleteProject(projectId: $projectId)
}
`;

export const getProjectQuery = queryAdmin(GET_PROJECT);
export const getProjectListQuery = queryAdmin(GET_PROJECT_LIST);
export const getProjectMembersQuery = queryAdmin(GET_PROJECT_MEMBERS);
export const getProjectAdminsQuery = queryAdmin(GET_PROJECT_ADMINS);

export const payloadFilter =
  (props) =>
  ({ payload }) =>
    pick(payload, props);

export const updateProjectPermissionsMutation = mutateAdmin(
  UPDATE_PROJECT_PERMISSIONS,
  payloadFilter(['userId', 'role'])
);

export const updateInviteRoleMutation = mutateAdmin(UPDATE_INVITATION_ROLE, payloadFilter(['email', 'role']));
export const cancelProjectInviteMutation = mutateAdmin(CANCEL_PROJECT_INVITE, payloadFilter(['email']));
export const removeProjectMemberMutation = mutateAdmin(REMOVE_PROJECT_MEMBER, payloadFilter(['userId']));
export const deleteProjectMutation = mutateAdmin(DELETE_PROJECT, payloadFilter(['projectId']));

export function inviteUser({ payload, meta }) {
  const params = {
    method: 'POST',
    path: `project/${meta.projectId}/invite-user`,
    data: payload
  };

  return api(params);
}

export function updateInviteStatus({ payload }) {
  const params = {
    method: 'POST',
    path: 'update-invite-status',
    data: payload
  };

  return api(params);
}

export function putS3({ url, file }) {
  const params = {
    method: 'PUT',
    body: file
  };

  return fetch(url, params);
}
